import React from 'react';
import { Grid, Dropdown, Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import AddSessionModal from 'PointOfSale/modules/servingOptions/container/AddSessionModal';
import AutoServeDropDownItems from 'PointOfSale/modules/layouts/component/servingOptions/AutoServeDropDownItems';
import SessionDropDownItems from 'PointOfSale/modules/layouts/component/servingOptions/SessionDropDownItems';
import QsiDropDownComponent from 'PointOfSale/modules/layouts/component/servingOptions/QsiDropDownComponent';
import IconWithPrimarySecondaryLabel from 'PointOfSale/modules/layouts/component/servingOptions/IconWithPrimarySecondaryLabel';
import PortalOverlay from 'PointOfSale/modules/common/component/PortalOverlay';
import {
  SessionTypes,
  AUTO_SERVE_OPTIONS,
  SessionTypeDetails,
} from 'PointOfSale/modules/common/constants';

import 'PointOfSale/styles/components/pageHeader.less';

const SessionMenuComponent = props => {
  const {
    openSession,
    openQSI,
    openAutoServe,
    openAddSessionModal,
    qsiMenuClick,
    autoServeClick,
    onQSIBlur,
    onAutoServeBlur,
    showHideAddSessionModal,
    quickServeItems,
    queueStatus,
    sessions,
    activeSession,
    onAutoServeClick,
    increment,
    decrement,
    onSessionClick,
    onQSIClick,
    sessionMenuClick,
    onSessionBlur,
    cepTypeId,
    onSessionAdd,
    hasMealCounterSession,
  } = props;
  const textWidth = '100%';

  const quickServeItemDescription = _.get(sessions, [
    activeSession,
    'quickServeItem',
    'Description',
  ]);
  const qsiTrigger = (
    <IconWithPrimarySecondaryLabel
      key="qsiTrigger"
      textWidth={textWidth}
      primaryLabel={'Quick Serve Item'}
      secondaryLabel={
        quickServeItemDescription ? quickServeItemDescription : 'None'
      }
    />
  );
  let autoServeDropdown = null;
  let autoServeTrigger = null;
  if (activeSession === SessionTypes.Queue && !hasMealCounterSession) {
    autoServeTrigger = (
      <IconWithPrimarySecondaryLabel
        key="pausedTrigger"
        textWidth={textWidth}
        primaryLabel="Auto Serve"
        secondaryLabel={queueStatus}
      />
    );
    autoServeDropdown = (
      <AutoServeDropDownItems
        sessions={sessions}
        activeSession={activeSession}
        queueStatus={queueStatus}
        onAutoServeClick={onAutoServeClick}
        increment={increment}
        decrement={decrement}
      />
    );
  }
  return (
    <React.Fragment>
      <Grid container columns={3}>
        <Grid.Column className="header-menu sessionMenuHeader">
          <Menu secondary>
            <Dropdown
              fluid
              item
              trigger={
                <IconWithPrimarySecondaryLabel
                  key="sessionTrigger"
                  textWidth={'80%'}
                  primaryLabel={'Session'}
                  secondaryLabel={
                    activeSession
                      ? SessionTypeDetails[activeSession].label
                      : activeSession
                  }
                />
              }
              icon={null}
              className="transparentBackground"
              open={openSession}
              onClick={sessionMenuClick}
              onBlur={onSessionBlur}
            >
              <Dropdown.Menu>
                <SessionDropDownItems
                  sessions={sessions}
                  activeSession={activeSession}
                  onSessionClick={onSessionClick}
                  onSessionAdd={onSessionAdd}
                />
              </Dropdown.Menu>
            </Dropdown>
          </Menu>
          <AddSessionModal
            open={openAddSessionModal}
            showHideAddSessionModal={showHideAddSessionModal}
            sessions={sessions}
            className="transparentBackground"
            activeSession={activeSession}
          />
        </Grid.Column>
        {qsiTrigger ? (
          <Grid.Column className="header-menu sessionMenuHeader">
            <Menu secondary>
              <Dropdown
                fluid
                trigger={qsiTrigger}
                item
                icon={null}
                open={openQSI}
                scrolling
                className="transparentBackground"
                onClick={qsiMenuClick}
                onBlur={onQSIBlur}
              >
                <Dropdown.Menu>
                  <QsiDropDownComponent
                    sessions={sessions}
                    activeSession={activeSession}
                    quickServeItems={quickServeItems}
                    onQSIClick={onQSIClick}
                  />
                </Dropdown.Menu>
              </Dropdown>
            </Menu>
          </Grid.Column>
        ) : null}
        {autoServeTrigger && autoServeDropdown ? (
          <Grid.Column className="header-menu sessionMenuHeader">
            <Menu secondary>
              <Dropdown
                fluid
                trigger={autoServeTrigger}
                item
                icon={null}
                open={openAutoServe}
                onClick={autoServeClick}
                onBlur={onAutoServeBlur}
                disabled={cepTypeId === AUTO_SERVE_OPTIONS.MealCounter}
              >
                <Dropdown.Menu>{autoServeDropdown}</Dropdown.Menu>
              </Dropdown>
            </Menu>
          </Grid.Column>
        ) : null}
      </Grid>
      {(openSession || openQSI || openAutoServe) && (
        <PortalOverlay
          modalRoot={document.getElementById('main-container-id')}
          divClassName={'opacityPoint2'}
        />
      )}
    </React.Fragment>
  );
};
SessionMenuComponent.propTypes = {
  openSession: PropTypes.bool,
  openQSI: PropTypes.bool,
  openAutoServe: PropTypes.bool,
  openAddSessionModal: PropTypes.bool,
  qsiMenuClick: PropTypes.func,
  autoServeClick: PropTypes.func,
  onQSIBlur: PropTypes.func,
  onAutoServeBlur: PropTypes.func,
  showHideAddSessionModal: PropTypes.func,
  quickServeItems: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  queueStatus: PropTypes.string,
  sessions: PropTypes.object,
  activeSession: PropTypes.string,
  onAutoServeClick: PropTypes.func,
  increment: PropTypes.func,
  decrement: PropTypes.func,
  onSessionClick: PropTypes.func,
  onQSIClick: PropTypes.func,
  sessionMenuClick: PropTypes.func,
  onSessionBlur: PropTypes.func,
};
export default SessionMenuComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/servingOptions/SessionMenu.js